/**
 * 企業ステージカテゴリー
 */
export const CompanyStageCode = {
  IPO: 'ipo',
  LATER: 'later',
  MIDDLE: 'middle',
  EARLY: 'early',
  SEED: 'seed',
  OTHER: 'other',
} as const

export type CompanyStageCodeValue =
  (typeof CompanyStageCode)[keyof typeof CompanyStageCode]

export const CompanyStageLabel: { [key: string]: string } = {
  [CompanyStageCode.IPO]: 'IPO',
  [CompanyStageCode.LATER]: 'レイター',
  [CompanyStageCode.MIDDLE]: 'ミドル',
  [CompanyStageCode.EARLY]: 'アーリー',
  [CompanyStageCode.SEED]: 'シード',
  [CompanyStageCode.OTHER]: 'その他',
}

export const CompanyStageValues = Object.entries(CompanyStageLabel).map(
  ([code, value]) => ({
    code,
    value,
  })
)